// Feature flags for HealthLink360 MVP
// These flags control which features are visible/enabled in the app

export const FEATURE_FLAGS = {
  // Facial scanning is hidden for MVP - underlying code remains intact
  FACIAL_SCANNING_ENABLED: false,
  
  // Wearable device connections
  DEVICE_CONNECTIONS_ENABLED: true,
  
  // AI features
  AI_COACHING_ENABLED: true,
  
  // Social features
  SOCIAL_SHARING_ENABLED: false,
  
  // Lab results integration
  LAB_RESULTS_ENABLED: false,
};

export default FEATURE_FLAGS;
